import React, { useEffect } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    window.scrollTo({ top: 1060, left: 0, behavior: "smooth" });
  }, [currentPage]);

  if (totalPages <= 1) return null;

  // Generate visible page numbers dynamically
  const getPageNumbers = () => {
    const maxVisible = 5; // max pages to show before ellipsis
    let pages = [];

    if (totalPages <= maxVisible + 2) {
      // Show all if total pages are small
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      // Always show first page
      pages.push(1);

      let start = Math.max(currentPage - 1, 2);
      let end = Math.min(currentPage + 1, totalPages - 1);

      if (currentPage <= 3) {
        start = 2;
        end = 4;
      }

      if (currentPage >= totalPages - 2) {
        start = totalPages - 3;
        end = totalPages - 1;
      }

      if (start > 2) {
        pages.push("..."); // left ellipsis
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages - 1) {
        pages.push("..."); // right ellipsis
      }

      pages.push(totalPages); // last page
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex justify-center gap-2 mt-8 mb-12 flex-wrap">
      {/* Previous Button */}
      <button
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="w-[2.5rem] h-[2.5rem] flex items-center justify-center rounded-full border border-gray-500 bg-white text-black hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition"
      >
        <IoIosArrowBack size={18} />
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((number, idx) => (
        <React.Fragment key={idx}>
          {number === "..." ? (
            <span className="w-[2.5rem] h-[2.5rem] flex items-center justify-center">
              ...
            </span>
          ) : (
            <button
              onClick={() => onPageChange(number)}
              className={`w-[2.5rem] h-[2.5rem] rounded-full font-semibold transition-colors duration-200 ${
                number === currentPage
                  ? "bg-gray-800 text-white"
                  : "bg-white text-black hover:bg-gray-800 hover:text-gray-500"
              }`}
            >
              {number}
            </button>
          )}
        </React.Fragment>
      ))}

      {/* Next Button */}
      <button
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        disabled={currentPage === totalPages}
        className="w-[2.5rem] h-[2.5rem] flex items-center justify-center rounded-full border border-gray-500 bg-white text-black hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition"
      >
        <IoIosArrowForward size={18} />
      </button>
    </div>
  );
};

export default Pagination;
